import React from "react";
import { useGetVideosQuery } from "../../../features/videos/videosApi";
import Error from "../../ui/Error";
import Video from "./Video";

export default function VideosList() {
  const { data: videos, isLoading, isError, error } = useGetVideosQuery() || {};

  let content = null;

  if (isLoading) {
    content = (
      <div className="w-full flex flex-row gap-2 cursor-pointer hover:bg-slate-900 p-2">
        Loading...
      </div>
    );
  } else if (!isLoading && isError) {
    content = (
      <div className="w-full flex flex-row gap-2 cursor-pointer hover:bg-slate-900 p-2">
        <Error message={error?.data} />
      </div>
    );
  } else if (!isLoading && !isError && videos?.length === 0) {
    content = (
      <div className="w-full flex flex-row gap-2 cursor-pointer hover:bg-slate-900 p-2">
        No Videos Found!
      </div>
    );
  } else if (!isLoading && !isError && videos?.length > 0) {
    content = videos.map((video) => {
      return <Video key={video.id} video={video} />;
    });
  }
  return (
    <div className="col-span-full lg:col-auto max-h-[570px] overflow-y-auto bg-secondary p-4 rounded-md border border-slate-50/10 divide-y divide-slate-600/30">
      {content}
    </div>
  );
}
